/* FusionHome — interacción */
(function(){
  function money(cents,fmt){
    var v=(cents/100).toFixed(2).split('.');
    var n=v[0].replace(/\B(?=(\d{3})+(?!\d))/g,'.')+','+v[1];
    return (fmt||'{{amount}} €').replace(/\{\{\s*amount[a-z_]*\s*\}\}/,n);
  }

  /* Pestañas */
  document.querySelectorAll('[data-fh-tabs]').forEach(function(root){
    var btns=root.querySelectorAll('[role=tab]');
    btns.forEach(function(b){
      b.addEventListener('click',function(){
        btns.forEach(function(x){x.setAttribute('aria-selected',x===b?'true':'false');var p=document.getElementById(x.getAttribute('aria-controls'));if(p)p.hidden=(x!==b);});
      });
    });
  });

  /* Menú móvil */
  document.querySelectorAll('[data-fh-open]').forEach(function(b){
    b.addEventListener('click',function(){var d=document.getElementById(b.getAttribute('data-fh-open'));if(d){d.setAttribute('open','');document.body.style.overflow='hidden';}});
  });
  document.querySelectorAll('[data-fh-close]').forEach(function(b){
    b.addEventListener('click',function(e){
      if(e.target!==b && !b.hasAttribute('data-fh-close-btn'))return;
      var d=b.closest('.fh-drawer');if(d){d.removeAttribute('open');document.body.style.overflow='';}
    });
  });

  /* Ordenar colección */
  document.querySelectorAll('[data-fh-sort]').forEach(function(s){
    s.addEventListener('change',function(){var u=new URL(location.href);u.searchParams.set('sort_by',s.value);u.searchParams.delete('page');location.href=u.toString();});
  });

  /* Ficha de producto */
  var root=document.querySelector('[data-fh-product]');
  if(!root)return;
  var data=JSON.parse(root.querySelector('[data-fh-json]').textContent);
  var variants=data.variants, fmt=data.money_format;
  var form=root.querySelector('form[data-fh-form]');
  var idInput=form.querySelector('input[name=id]');
  var priceEl=root.querySelector('[data-fh-price]'), cmpEl=root.querySelector('[data-fh-compare]');
  var btn=form.querySelector('[data-fh-add]'), err=root.querySelector('[data-fh-err]');
  var selEls=root.querySelectorAll('[data-fh-optval]');
  var mainImg=root.querySelector('[data-fh-main]'), thumbs=root.querySelectorAll('[data-fh-thumb]');
  var media=data.media, cur=0;

  function show(i){
    if(!media.length||!mainImg)return;
    cur=(i+media.length)%media.length;
    mainImg.src=media[cur].src; mainImg.srcset=media[cur].srcset||''; mainImg.alt=media[cur].alt||'';
    thumbs.forEach(function(t,k){t.setAttribute('aria-current',k===cur?'true':'false');});
    var t=thumbs[cur]; if(t){t.parentNode.scrollTo({left:t.offsetLeft-t.parentNode.offsetLeft-40,behavior:'smooth'});}
  }
  thumbs.forEach(function(t,k){t.addEventListener('click',function(){show(k);});});
  var pv=root.querySelector('[data-fh-prev]'),nx=root.querySelector('[data-fh-next]');
  if(pv)pv.addEventListener('click',function(){show(cur-1);});
  if(nx)nx.addEventListener('click',function(){show(cur+1);});
  thumbs.forEach(function(t,k){if(t.getAttribute('aria-current')==='true')cur=k;});

  function selected(){
    var s=[];
    root.querySelectorAll('[data-fh-option]').forEach(function(g){var c=g.querySelector('input:checked');s.push(c?c.value:null);});
    return s;
  }
  function find(sel){
    for(var i=0;i<variants.length;i++){var v=variants[i],ok=true;for(var j=0;j<sel.length;j++){if(v.options[j]!==sel[j]){ok=false;break;}}if(ok)return v;}
    return null;
  }
  function refreshAvail(sel){
    root.querySelectorAll('[data-fh-option]').forEach(function(g,idx){
      g.querySelectorAll('input').forEach(function(inp){
        var exists=variants.some(function(v){for(var j=0;j<idx;j++){if(v.options[j]!==sel[j])return false;}return v.options[idx]===inp.value;});
        inp.closest('label').classList.toggle('is-hidden',!exists);
      });
    });
  }
  function update(fromUser){
    if(!variants.length)return;
    var sel=selected(), v=find(sel);
    if(!v){
      var alt=variants.find(function(x){return x.options[0]===sel[0];})||variants[0];
      root.querySelectorAll('[data-fh-option]').forEach(function(g,j){g.querySelectorAll('input').forEach(function(inp){inp.checked=(inp.value===alt.options[j]);});});
      sel=selected();v=alt;
    }
    refreshAvail(sel);
    root.querySelectorAll('[data-fh-option]').forEach(function(g,j){var o=g.querySelector('[data-fh-optcur]');if(o)o.textContent=sel[j]||'';});
    idInput.value=v.id;
    priceEl.textContent=money(v.price,fmt);
    if(cmpEl){if(v.compare_at_price&&v.compare_at_price>v.price){cmpEl.textContent=money(v.compare_at_price,fmt);cmpEl.hidden=false;}else{cmpEl.hidden=true;}}
    btn.disabled=!v.available; btn.textContent=v.available?btn.getAttribute('data-label-add'):btn.getAttribute('data-label-na');
    if(fromUser&&v.featured_media_index!=null)show(v.featured_media_index);
    if(fromUser&&history.replaceState){var u=new URL(location.href);u.searchParams.set('variant',v.id);history.replaceState({},'',u.toString());}
  }
  selEls.forEach(function(i){i.addEventListener('change',function(){update(true);});});
  update(false);

  var q=form.querySelector('input[name=quantity]');
  form.querySelectorAll('[data-fh-q]').forEach(function(b){b.addEventListener('click',function(){var n=parseInt(q.value||'1',10)+parseInt(b.getAttribute('data-fh-q'),10);q.value=Math.max(1,n);});});

  form.addEventListener('submit',function(e){
    e.preventDefault(); err.textContent='';
    var label=btn.textContent; btn.disabled=true; btn.textContent=btn.getAttribute('data-label-busy');
    var rootUrl=(window.Shopify&&Shopify.routes&&Shopify.routes.root)||'/';
    fetch(rootUrl+'cart/add.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({items:[{id:parseInt(idInput.value,10),quantity:parseInt(q.value||'1',10)}]})})
      .then(function(r){return r.json().then(function(j){return {ok:r.ok,j:j};});})
      .then(function(res){
        if(!res.ok){err.textContent=res.j.description||res.j.message||'No se ha podido añadir.';btn.disabled=false;btn.textContent=label;return;}
        location.href=rootUrl+'cart';
      })
      .catch(function(){form.submit();});
  });
})();
